import React, { useState, useEffect } from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'
import * as echarts from 'echarts'

export default function GeoChoroplethAndScatter({
  compStyle = { height: '400px', width: '100%' },
  provinceDataFrom = [],
  onClickCheart = () => {},
  ...props
}) {
  const [chartOption, setChartOption] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const initMap = async () => {
      setLoading(true)
      // await mapDatasProvince()
      await loadMap()
      setLoading(false)
    }

    initMap()
  }, [])

  // ข้อมูลพิกัด Longitude และ Latitude ทั้งหมด 77 จังหวัดของประเทศไทย
  const thailandProvinces = [
    // ภาคเหนือ (17 จังหวัด)
    { name: 'เชียงใหม่', longitude: 98.9917, latitude: 18.7883 },
    { name: 'เชียงราย', longitude: 99.8325, latitude: 19.9105 },
    { name: 'กำแพงเพชร', longitude: 99.5189, latitude: 16.4827 },
    { name: 'ลำปาง', longitude: 99.4981, latitude: 18.2928 },
    { name: 'ลำพูน', longitude: 99.0058, latitude: 18.5744 },
    { name: 'แม่ฮ่องสอน', longitude: 97.9686, latitude: 19.3011 },
    { name: 'น่าน', longitude: 100.7797, latitude: 18.7756 },
    { name: 'นครสวรรค์', longitude: 100.1372, latitude: 15.7047 },
    { name: 'พะเยา', longitude: 99.8956, latitude: 19.1717 },
    { name: 'เพชรบูรณ์', longitude: 101.1569, latitude: 16.4192 },
    { name: 'พิจิตร', longitude: 100.3489, latitude: 16.4372 },
    { name: 'พิษณุโลก', longitude: 100.2658, latitude: 16.8289 },
    { name: 'แพร่', longitude: 100.145, latitude: 18.1447 },
    { name: 'สุโขทัย', longitude: 99.8233, latitude: 17.0139 },
    { name: 'ตาก', longitude: 99.1267, latitude: 16.8839 },
    { name: 'อุตรดิตถ์', longitude: 100.0994, latitude: 17.6258 },
    { name: 'อุทัยธานี', longitude: 100.0247, latitude: 15.3794 },

    // ภาคกลาง (22 จังหวัد)
    { name: 'กรุงเทพมหานคร', longitude: 100.5018, latitude: 13.7563 },
    { name: 'กาญจนบุรี', longitude: 99.5328, latitude: 14.0228 },
    { name: 'ชัยนาท', longitude: 100.125, latitude: 15.1858 },
    { name: 'นครนายก', longitude: 101.2131, latitude: 14.2069 },
    { name: 'นครปฐม', longitude: 100.0619, latitude: 13.8199 },
    { name: 'นนทบุรี', longitude: 100.5144, latitude: 13.8622 },
    { name: 'ปทุมธานี', longitude: 100.525, latitude: 14.0208 },
    { name: 'พระนครศรีอยุธยา', longitude: 100.5647, latitude: 14.3692 },
    { name: 'ลพบุรี', longitude: 100.6531, latitude: 14.7969 },
    { name: 'สมุทรปราการ', longitude: 100.5936, latitude: 13.5991 },
    { name: 'สมุทรสงคราม', longitude: 100.0, latitude: 13.4139 },
    { name: 'สมุทรสาคร', longitude: 100.2744, latitude: 13.5475 },
    { name: 'สระบุรี', longitude: 100.9106, latitude: 14.5289 },
    { name: 'สิงห์บุรี', longitude: 100.3969, latitude: 14.8936 },
    { name: 'สุพรรณบุรี', longitude: 100.1156, latitude: 14.4744 },
    { name: 'อ่างทอง', longitude: 100.4547, latitude: 14.5894 },
    { name: 'ราชบุรี', longitude: 99.8131, latitude: 13.5283 },
    { name: 'เพชรบุรี', longitude: 99.9392, latitude: 13.1119 },
    { name: 'ประจวบคีรีขันธ์', longitude: 99.7975, latitude: 11.8106 },

    // ภาคตะวันออก (7 จังหวัด)
    { name: 'จันทบุรี', longitude: 102.1089, latitude: 12.6103 },
    { name: 'ฉะเชิงเทรา', longitude: 101.0717, latitude: 13.6904 },
    { name: 'ชลบุรี', longitude: 100.9847, latitude: 13.3611 },
    { name: 'ปราจีนบุรี', longitude: 101.3731, latitude: 14.0508 },
    { name: 'ระยอง', longitude: 101.2539, latitude: 12.6808 },
    { name: 'สระแก้ว', longitude: 102.0647, latitude: 13.8239 },
    { name: 'ตราด', longitude: 102.5156, latitude: 12.2431 },

    // ภาคตะวันออกเฉียงเหนือ (20 จังหวัด)
    { name: 'กาฬสินธุ์', longitude: 103.5061, latitude: 16.4322 },
    { name: 'ขอนแก่น', longitude: 102.8431, latitude: 16.4419 },
    { name: 'ชัยภูมิ', longitude: 102.0314, latitude: 15.8069 },
    { name: 'นครพนม', longitude: 104.7781, latitude: 17.4069 },
    { name: 'นครราชสีมา', longitude: 102.0977, latitude: 14.9799 },
    { name: 'บึงกาฬ', longitude: 103.6469, latitude: 18.3583 },
    { name: 'บุรีรัมย์', longitude: 103.1031, latitude: 14.9939 },
    { name: 'มหาสารคาม', longitude: 103.3019, latitude: 15.7797 },
    { name: 'มุกดาหาร', longitude: 104.7236, latitude: 16.5431 },
    { name: 'ยโสธร', longitude: 104.145, latitude: 15.7928 },
    { name: 'ร้อยเอ็ด', longitude: 103.6533, latitude: 16.0544 },
    { name: 'เลย', longitude: 101.7328, latitude: 17.4864 },
    { name: 'ศรีสะเกษ', longitude: 104.3222, latitude: 15.1186 },
    { name: 'สกลนคร', longitude: 104.1389, latitude: 17.1553 },
    { name: 'สุรินทร์', longitude: 103.4939, latitude: 14.8825 },
    { name: 'หนองคาย', longitude: 102.7417, latitude: 17.8783 },
    { name: 'หนองบัวลำภู', longitude: 102.4411, latitude: 17.2042 },
    { name: 'อำนาจเจริญ', longitude: 104.6267, latitude: 15.8653 },
    { name: 'อุดรธานี', longitude: 102.816, latitude: 17.4138 },
    { name: 'อุบลราชธานี', longitude: 104.8441, latitude: 15.2286 },

    // ภาคใต้ (14 จังหวัด)
    { name: 'ชุมพร', longitude: 99.18, latitude: 10.493 },
    { name: 'กระบี่', longitude: 99.0928, latitude: 8.0863 },
    { name: 'นครศรีธรรมราช', longitude: 99.9631, latitude: 8.4304 },
    { name: 'นราธิวาส', longitude: 101.8253, latitude: 6.4239 },
    { name: 'ปัตตานี', longitude: 101.2506, latitude: 6.8681 },
    { name: 'พังงา', longitude: 98.5328, latitude: 8.4506 },
    { name: 'พัทลุง', longitude: 100.0742, latitude: 7.6164 },
    { name: 'ภูเก็ต', longitude: 98.3381, latitude: 7.8804 },
    { name: 'ระนอง', longitude: 98.6372, latitude: 9.9658 },
    { name: 'สงขลา', longitude: 100.5956, latitude: 7.0067 },
    { name: 'สตูล', longitude: 99.6117, latitude: 6.6239 },
    { name: 'สุราษฎร์ธานี', longitude: 99.3317, latitude: 9.1382 },
    { name: 'ตรัง', longitude: 99.6036, latitude: 7.5689 },
    { name: 'ยะลา', longitude: 101.2806, latitude: 6.5406 },
  ]

  // const provinceDataFrom = [
  //   {
  //     name: 'เชียงใหม่',
  //     center: null,
  //     data: [
  //       { value: 40, name: 'R1' },
  //       { value: 60, name: 'R2' },
  //     ],
  //   },
  //   {
  //     name: 'เชียงราย',
  //     center: null,
  //     data: [
  //       { value: 35, name: 'R1' },
  //       { value: 65, name: 'R2' },
  //     ],
  //   },
  // ]

  const mapDatasProvince = () => {
    let newArr = []
    // console.log('provinceDataFrom => ', provinceDataFrom)
    provinceDataFrom.map((item) => {
      thailandProvinces.map((thaiProv) => {
        if (item.name == thaiProv.name) {
          // console.log('thaiProv => ', thaiProv)
          // console.log('item => ', item)

          let subNewArr = []
          subNewArr[0] = thaiProv.longitude
          subNewArr[1] = thaiProv.latitude
          subNewArr[2] = item.value
          subNewArr[3] = item.name
          subNewArr[4] = item.id

          // console.log('subbbb => ', subNewArr)

          newArr.push(subNewArr)
        }
      })
    })

    return newArr
  }

  const loadMap = async () => {
    try {
      const response = await import('../thailand.json')
      const thailandJson = response.default

      // register แผนที่ประเทศไทย
      echarts.registerMap('thailand', thailandJson)

      // สร้าง series สำหรับแต่ละจังหวัด

      let provinceData = await mapDatasProvince()

      // console.log('ggggg => ', provinceData)

      // const scatterSeries = provinceData.map((province, index) => ({
      //   type: 'scatter',
      //   coordinateSystem: 'geo', // ใช้ geo coordinate system
      //   geoIndex: 0, // อ้างอิงไปยัง geo component แรก
      //   encode: {
      //     // `2` is the dimension index of series.data
      //     tooltip: 2,
      //     label: 2,
      //   },
      //   data: [],
      // }))

      setChartOption({
        geo: {
          name: 'Thailand',
          map: 'thailand',
          roam: true,
          itemStyle: {
            areaColor: '#e7e8ea',
            borderColor: '#999',
            borderWidth: 1,
          },
          emphasis: {
            label: { show: false },
            itemStyle: {
              areaColor: '#b3d9ff',
            },
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            // console.log('params => ', params)
            return `<div>
            <strong>พื้นที่รับผิดชอบ : </strong> ${params.data[3]} <br />
            <strong>จำนวนโครงการ : </strong> ${params.data[2]}
            </div>`
          },
        },
        series: {
          type: 'scatter',
          coordinateSystem: 'geo',
          geoIndex: 0,
          encode: {
            // `2` is the dimension index of series.data
            tooltip: 2,
            label: 2,
          },
          data: provinceData,
          // data: [
          //   [98.9917, 18.7883, 149, 'เชียงใหม่'],
          //   [99.8325, 19.9105, 675, 'เชียงราย'],
          // ],
          itemStyle: {
            color: '#6694c2ff',
            borderWidth: 1,
            borderColor: '#483c78ff',
          },
        },
      })
    } catch (error) {
      console.error('Error loading Thailand map:', error)
    }
  }

  const onEvents = {
    click: (params) => {
      // console.log('คลิกที่:', params)
      onClickCheart(params.data)
    },
    // mouseover: (params) => {
    //   console.log('Hover:', params.name)
    // },
  }

  if (!chartOption) {
    return <div>กำลังโหลดแผนที่...</div>
  }

  return (
    <div>
      <ReactECharts option={chartOption} style={compStyle} onEvents={onEvents} />
    </div>
  )
}
